var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 29,
    viewBox: "0 0 16 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5451 27.8969C14.9593 28.4827 14.0058 28.4865 13.42 27.9007L1.06066 15.5413C0.474876 14.9556 0.474875 14.0058 1.06066 13.42L13.42 1.06066C14.0058 0.474876 14.9593 0.478645 15.5451 1.06443C16.1309 1.65023 16.1347 2.60376 15.5489 3.18955L5.3181 13.42C4.73229 14.0058 4.73229 14.9556 5.3181 15.5414L15.5489 25.7718C16.1347 26.3576 16.1309 27.3111 15.5451 27.8969Z",
    fill: "#A2C357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackIos);
export default __webpack_public_path__ + "static/media/arrow_back_ios.36c8b956855d1b414c77b5827f0aa544.svg";
export { ForwardRef as ReactComponent };